import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, Observer, filter, from, fromEvent, map, max, reduce, scan, take } from 'rxjs';
import { UserAuthResponse } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup; //the exclamation point is to bypass the initizalizer
  errorMessage: string = "";

  constructor(
    private formBuilder: FormBuilder, 
    private userService: UserService,
    private router: Router) {}  

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  login() {
    this.errorMessage = "";
    if (this.loginForm.valid) {
      this.userService.login(this.loginForm.value.username, this.loginForm.value.password).subscribe({
        next: (user: UserAuthResponse) => { 
          //determine where to land based on the role.
          if (user.user.role) {
            //this.router.navigateByUrl(`/${user.user.role}-home`);
            this.router.navigateByUrl(`/home/${user.user.role}`);
          } else {
            this.router.navigateByUrl('/');
          }
        }, 
        error: error => {
          console.log(error);
          this.errorMessage = "Let's try with correct Username/Password"
        }
      });
    }
  }
}